import { StyledImage } from "@/shared/components/StyledImageComponent/StyledImageComponent";
import ENV from "../../env";

const Logo: React.FC = () => {
  return (
    <div className="flex justify-center logo-container">
      <div className="image-container">
        <StyledImage type="logo" rootApiPath={ENV.API_SERVER} fallBack={`${ENV.BASE_PATH}/logo.svg`} className="styled-image w-full h-full" />
      </div>
    </div>
  );
};

export default Logo;
